import { render, staticRenderFns } from "./AssetReplaceNotAllowedPopUp.vue?vue&type=template&id=6ac9c284&lang=pug&"
import script from "./AssetReplaceNotAllowedPopUp.vue?vue&type=script&lang=js&"
export * from "./AssetReplaceNotAllowedPopUp.vue?vue&type=script&lang=js&"
import style0 from "./AssetReplaceNotAllowedPopUp.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports